import { formatNewsPublishDate } from 'shared/entities/news';
import type { NewsFeedItem } from 'shared/newEntities/newsFeed';

export const formatPublishDate = formatNewsPublishDate;

export const getNewsModalSubtitle = (
  news: NewsFeedItem,
  openedAt: Date
): string | undefined =>
  formatPublishDate(
    news.publishDate || (news.isTestActive ? openedAt.toISOString() : null)
  );
